import {StorageKeys} from "../consts/storageKeys.ts";
import {IStorageService} from "./IStorageService.ts";

export class LocalStorageService implements IStorageService {
    getItem<T>(key:StorageKeys){
        const localstorageItemString = localStorage.getItem(key);
        if (localstorageItemString)
            return JSON.parse(localstorageItemString) as T;
        return null;
    }
    setItem<T>(key:StorageKeys, value: T) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    removeItem(key: StorageKeys): void {
        localStorage.removeItem(key);
    }
}
